// Поле суммы: что пользователь набирает и что уходит на сервер.

/** Сумма из поля: «25 000» → 25000, «12,5» → 12.5; пусто или ноль — null. */
export function parseAmount(raw: string): number | null {
  const n = Number(raw.replace(/[\s ]/g, "").replace(",", "."));
  return Number.isFinite(n) && n > 0 ? n : null;
}

/** Оставляет цифры (и для долларов — одну точку с двумя знаками). */
export function cleanAmount(input: string, decimals: boolean): string {
  let s = input.replace(/[\s ]/g, "").replace(",", ".");
  s = s.replace(decimals ? /[^\d.]/g : /\D/g, "");
  if (decimals) {
    const [int = "", ...rest] = s.split(".");
    s = rest.length ? `${int}.${rest.join("").slice(0, 2)}` : int;
  }
  return s.replace(/^0+(?=\d)/, "").slice(0, 13);
}

/** «1250000» → «1 250 000». */
export function groupDigits(raw: string): string {
  const [int = "", dec] = raw.split(".");
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return dec !== undefined ? `${grouped}.${dec}` : grouped;
}
